import { keyframes } from '@xstyled/styled-components'

export const slideInFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translate(-20%, 0%);
  }
  to {
    opacity: 1;
    transform: translate(0);
  }
`

export const slideInFromTop = keyframes`
  from {
    opacity: 0;
    transform: translate(0%, -100%);
  }
  to {
    opacity: 1;
    transform: translate(0);
  }
`

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

export const wait = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 0;
  }
`
